import { PAISES } from "../data/paises";

const PAISES_SET = new Set(PAISES.map((p) => p.code));

/** Convierte código ISO-2 en emoji de bandera (🇪🇸). */
export function countryFlag(code) {
  const cc = String(code || "")
    .trim()
    .toUpperCase();
  if (!/^[A-Z]{2}$/.test(cc)) return "";
  return String.fromCodePoint(
    ...[...cc].map((c) => 127397 + c.charCodeAt(0))
  );
}

export function countryLabel(code, name) {
  const flag = countryFlag(code);
  return flag ? `${flag} ${name}` : name;
}

/**
 * Intenta deducir el país desde el idioma/locale del navegador.
 * Ej: es-ES → ES, en-US → US, es → ES (maximize).
 */
export function detectCountryFromBrowser() {
  const candidates = [];
  try {
    if (typeof navigator !== "undefined") {
      for (const loc of [...(navigator.languages || []), navigator.language]) {
        if (!loc) continue;
        candidates.push(String(loc));
      }
    }
  } catch {
    // ignore
  }

  for (const loc of candidates) {
    try {
      const normalized = loc.replace("_", "-");
      const parts = normalized.split("-");
      for (let i = parts.length - 1; i >= 1; i -= 1) {
        const code = parts[i].toUpperCase();
        if (/^[A-Z]{2}$/.test(code) && PAISES_SET.has(code)) return code;
      }
      if (typeof Intl !== "undefined" && Intl.Locale) {
        const region = new Intl.Locale(normalized).maximize().region;
        if (region && PAISES_SET.has(region.toUpperCase())) {
          return region.toUpperCase();
        }
      }
    } catch {
      // siguiente locale
    }
  }

  return PAISES_SET.has("ES") ? "ES" : "";
}
